import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_date_technical } from '../../functions/functions_formatting.js';


export default class Userlist extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {

        return (
            <div className="admindashboard__section">
                <div className="admindashboard__section__title text-title">
                    Users
                </div>
                <div className="admindashboard__section__content">
                    {(this.props.userdata && this.props.userdata.length >= 1) &&
                        <div className="admindashboard__section__content__table admindashboard__section__content__table--user">

                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                User ID
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Username
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Full name
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Account type
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Country, hometown
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Created
                            </div>

                            {this.props.userdata.map((user, i) => (
                                <React.Fragment key={i}>
                                    <div onClick={() => this.props.setUser(user.user_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                        {user.user_id ? user.user_id : "-"}
                                    </div>
                                    <Link to={"/u/" + user.username} className="admindashboard__section__content__table__element">
                                        {user.username ? user.username : "-"}
                                    </Link>
                                    <div className="admindashboard__section__content__table__element">
                                        {user.name ? user.name : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {user.account_type ? user.account_type : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {user.hometown ? user.hometown : ""}
                                        {user.country && user.hometown ? ", " : "-"}
                                        {user.country ? user.country : ""}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {format_date_technical(user.created)}
                                    </div>
                                </React.Fragment>
                            ))}

                        </div>
                    }
                </div>
            </div>
        )
    }
}